import { render, staticRenderFns } from "./BusinessContactSettingsView.vue?vue&type=template&id=57081fca&scoped=true&"
import script from "./BusinessContactSettingsView.vue?vue&type=script&lang=ts&"
export * from "./BusinessContactSettingsView.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessContactSettingsView.vue?vue&type=style&index=0&id=57081fca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57081fca",
  null
  
)

export default component.exports